import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Process from './Process';
import Stats from './Stats';
import Projects from './Projects';
import Footer from './Footer';
import Blog from './Blog';
import Contact from './Contact';
import ScrollToTop from './ScrollToTop';

// Note : Suppression de la dépendance à LandingPage.css car nous utilisons Tailwind maintenant.
// S'il y avait des styles critiques là-bas, ils devraient être migrés.

const LandingPage: React.FC = () => {
    return (
        <div className="font-sans text-gray-800 bg-white overflow-x-hidden w-full">
            <Navbar />
            <Hero />
            <About />
            <Services />
            <Process />
            {/* La section Stats dans l'image est en fait une bande à l'intérieur/au-dessus des projets ou en dessous du processus. 
                Basé sur les mises en page standard, nous la plaçons avant les projets. 
            */}
            <Stats />
            <Projects />
            <Blog />
            <Contact />
            <Footer />
            <ScrollToTop />
        </div>
    );
};

export default LandingPage;
